export default __webpack_public_path__ + "img/WB.a7a7adc5d0ed0ce7432a506a14f45282.jpg";